import { render, staticRenderFns } from "./changeNewPhone.vue?vue&type=template&id=07686a00&scoped=true"
import script from "./changeNewPhone.vue?vue&type=script&lang=js"
export * from "./changeNewPhone.vue?vue&type=script&lang=js"
import style0 from "./changeNewPhone.vue?vue&type=style&index=0&id=07686a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07686a00",
  null
  
)

export default component.exports